import { render, staticRenderFns } from "./selectIssue.vue?vue&type=template&id=40fe770b&scoped=true"
import script from "./selectIssue.vue?vue&type=script&lang=js"
export * from "./selectIssue.vue?vue&type=script&lang=js"
import style0 from "./selectIssue.vue?vue&type=style&index=0&id=40fe770b&prod&lang=css"
import style1 from "./selectIssue.vue?vue&type=style&index=1&id=40fe770b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fe770b",
  null
  
)

export default component.exports